export interface EmptyTableProps {
	readonly title: string;
	readonly subtitle: string | React.ReactNode | React.ReactNode[];
	readonly icon?: React.ReactNode | string;
	readonly color?: string;
	readonly iconColor?: string;
	readonly titleColor?: string;
	readonly captionColor?: string;
	readonly CTA?: React.ReactNode;
	readonly dataCy?: string;
	readonly className?: string;
}
